import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRightIcon } from '../../components/ui/Icons';

const MOCK_NEWS = [
    {
        id: 1,
        title: "Tesla's Q4 deliveries beat expectations, stock jumps 5%",
        source: "Bloomberg",
        time: "2 hours ago",
        related: ["TSLA", "EV"],
        image: "https://placehold.co/600x400/e2e8f0/1e293b?text=TSLA"
    },
    {
        id: 2,
        title: "Fed signals potential rate cuts in late 2025 as inflation cools",
        source: "Reuters",
        time: "4 hours ago",
        related: ["Market", "Economy"],
        image: "https://placehold.co/600x400/e2e8f0/1e293b?text=FED"
    },
    {
        id: 3,
        title: "NVIDIA unveils new AI chip for consumer devices",
        source: "TechCrunch",
        time: "5 hours ago",
        related: ["NVDA", "AI"],
        image: "https://placehold.co/600x400/e2e8f0/1e293b?text=NVDA"
    },
    {
        id: 4,
        title: "Oil prices stabilize after volatile week in global markets",
        source: "CNBC",
        time: "1 day ago",
        related: ["Commodities", "Oil"],
        image: "https://placehold.co/600x400/e2e8f0/1e293b?text=OIL"
    }
];

const StockNews: React.FC = () => {
    return (
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 animate-fade-in">
            {/* Breadcrumbs */}
            <nav className="flex items-center space-x-2 text-sm text-slate-500 mb-6">
                <Link to="/dashboard" className="hover:text-trade-primary transition-colors">Manage</Link>
                <ChevronRightIcon className="w-4 h-4" />
                <span className="text-slate-900 font-medium">News & Insights</span>
            </nav>

            <div className="mb-8">
                <h1 className="text-3xl font-bold text-slate-900 tracking-tight">Market News</h1>
                <p className="text-slate-600 mt-2 text-lg">
                    Curated news and insights relevant to your portfolio.
                </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                {MOCK_NEWS.map((news) => (
                    <article key={news.id} className="bg-white rounded-xl shadow-sm border border-slate-100 overflow-hidden hover:shadow-md transition-shadow">
                        <div className="h-48 bg-slate-200 relative overflow-hidden">
                            <div className="absolute inset-0 flex items-center justify-center text-slate-400 font-medium">
                                {/* Placeholder for actual news images */}
                                <img src={news.image} alt={news.title} className="w-full h-full object-cover" />
                            </div>
                        </div>
                        <div className="p-6">
                            <div className="flex items-center justify-between mb-3">
                                <span className="text-xs font-bold text-blue-600 uppercase tracking-wider">{news.source}</span>
                                <span className="text-xs text-slate-500">{news.time}</span>
                            </div>
                            <h3 className="text-xl font-bold text-slate-900 mb-3 line-clamp-2 hover:text-blue-600 cursor-pointer">
                                {news.title}
                            </h3>
                            <div className="flex flex-wrap gap-2 mt-4">
                                {news.related.map(tag => (
                                    <span key={tag} className="px-2 py-1 bg-slate-100 text-slate-600 rounded text-xs font-medium">
                                        #{tag}
                                    </span>
                                ))}
                            </div>
                        </div>
                    </article>
                ))}
            </div>

            <div className="mt-12 text-center">
                <button className="btn btn-secondary px-8">
                    Load More News
                </button>
            </div>
        </div>
    );
};

export default StockNews;
